import { Pipe, PipeTransform } from '@angular/core';
import { NewsfeedNotificationObservables } from '../globals';

@Pipe({
  name: 'newsfeedObservable'
})
export class NewsfeedObservablePipe implements PipeTransform {

  transform(value: number): string {
    switch (value) {
      case NewsfeedNotificationObservables.IssueCreation:
        return `Erstellung eines Vorangs`;

      case NewsfeedNotificationObservables.IssueChange:
        return `Änderung eines Vorgangs`;

      case NewsfeedNotificationObservables.IssueDeletion:
        return `Löschung eines Vorgangs`;

      case NewsfeedNotificationObservables.IncomingEMail:
        return `Eingehende E-Mail`;

      case NewsfeedNotificationObservables.OutgoingEMail:
        return `Ausgehende E-Mail`;

      case NewsfeedNotificationObservables.IssueItemCreation:
        return `Erstellung eines Vorgangartikels`;

      case NewsfeedNotificationObservables.IssueItemChange:
        return `Änderung eines Vorgangartikels`;

      case NewsfeedNotificationObservables.IssueItemDeletion:
        return `Löschung eines Vorgangartikels`;
    }
  }

}
